import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { FormField } from '@angular/forms/signals';

import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {
  DialogModule,
  WindowModule,
} from '@progress/kendo-angular-dialog';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

import { InAppHelpModule as BaseModule } from '@ups/xplat/base/in-app-help';

import { COMPONENTS } from './components';
import { DIRECTIVES } from './directives';
import { WALKTHROUGH_WEB_PROVIDERS } from './services/walkthrough-web.providers';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormField,
    BaseModule,
    TooltipModule,
    DropDownListModule,
    InputsModule,
    DialogModule,
    WindowModule,
    LayoutModule,
    ButtonsModule,
    EditorModule,
  ],
  declarations: [...COMPONENTS, ...DIRECTIVES],
  exports: [...COMPONENTS, ...DIRECTIVES],
  providers: [...WALKTHROUGH_WEB_PROVIDERS],
})
export class InAppHelpModule {}
